import { render } from "./CompanySubmissionDateCell.vue?vue&type=template&id=634a79ac&ts=true"
import script from "./CompanySubmissionDateCell.vue?vue&type=script&lang=ts"
export * from "./CompanySubmissionDateCell.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__